import { DisplayGroup } from '@common/components/forms/fields';
import { PageCard } from '@common/components/layout';
import { useCurrentRoute } from '@common/hooks';
import { HospitalModel, IHospitalHoursModel } from '@common/models';
import { WeekDay } from '@common/models/Enums';
import { LocationDetailUsersList } from '@hospital/views/shared/locations';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { LocationDetailStaticInfo } from './LocationDetailStaticInfo';
interface IProps {
    hospital: HospitalModel
}

export const LocationDetailView = observer(({ hospital }: IProps) => {
    const currentRoute = useCurrentRoute();
    const isAdmin = currentRoute?.pathname.toLowerCase().startsWith("/admin");
    const userProfileBaseUrl = isAdmin ? "../../users/" : "../users/";
    return (<Row>
        <Col xs={8}>
            <LocationDetailStaticInfo hospital={hospital} />
            <PageCard className="mt-4" title="Hospital Details">
                <Row className="pt-4">
                    <Col md={4}>
                        <DisplayGroup controlid="phone" text="Phone" value={hospital.phone} />
                    </Col>
                    <Col md={4}>
                        <DisplayGroup controlid="sms" text="SMS" value={hospital.outboundSMSPhone} />
                    </Col>
                    <Col md={4}>
                        <DisplayGroup controlid="fax" text="Fax" value={hospital.fax} />
                    </Col>
                </Row>
                <Row className="pt-4">
                    <Col md={6}>
                        <DisplayGroup controlid="email" text="Email" value={hospital.email} />
                    </Col>
                    <Col md={6}>
                        <DisplayGroup controlid="url" text="URL" value={hospital.url} />
                    </Col>
                </Row>
            </PageCard>
            <PageCard className="mt-4" title="Hours of Operation">
                <div className="hours-operation d-inline-flex flex-column mt-2">
                    {hospital.hospitalHours
                        .slice()
                        .sort(byDayOfWeek)
                        .map((field, index) => (
                            <div className="d-flex flex-row mb-1" key={field.dayOfWeek}>
                                <div className="d-inline-flex flex-row justify-content-start align-items-baseline">
                                    <div className="d-flex day-label text-left fw-bold text-uppercase me-4">
                                        {WeekDay.getLongName(index)}
                                    </div>
                                    <div className="d-inline-flex flex-lg-row flex-md-column justify-content-center">
                                        {!field.isOpen && <em>Closed</em>}
                                        {field.isOpen && <>
                                            <div className="time" aria-label={`${WeekDay.getShortName(index)} open time`}>
                                                {DateTime.fromISO(field.openTime).toLocaleString(DateTime.TIME_SIMPLE)}
                                            </div>
                                            <div className="divider align-self-center px-2">-</div>
                                            <div className="time" aria-label={`${WeekDay.getShortName(index)} close time`}>
                                                {DateTime.fromISO(field.closeTime).toLocaleString(DateTime.TIME_SIMPLE)}
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </PageCard>
        </Col>
        <Col xs={4}>
            <LocationDetailUsersList className="mt-4 mt-xl-0" hospital={hospital} userProfileBaseUrl={userProfileBaseUrl} />
        </Col>
    </Row>
    )
});

const byDayOfWeek = (a: IHospitalHoursModel, b: IHospitalHoursModel) =>
    a.dayOfWeek < b.dayOfWeek ? -1 : 1;
